import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=755371cc&"
import script from "./publication.vue?vue&type=script&lang=js&"
export * from "./publication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports